import {
  Collapse, Colors, Icon,
} from '@honeyscience/honey-ui-toolkit';
import React, { ReactElement, useState } from 'react';
import { createUseStyles } from 'react-jss';
import { Link } from 'react-router-dom';
import { LINK_TO_PATH_MAP } from 'mockStores/lib/constants';
import { LinkNames } from 'mockStores/lib/types';

const useStyles = createUseStyles({
  collapseArrow: {
    marginLeft: '4px',
  },
  collapsibleContent: {
    display: 'flex',
    flexDirection: 'column',
    height: 'fit-content',
    justifyContent: 'center',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '40px',
    width: '800px',
  },
  expandButton: {
    alignItems: 'center',
    color: Colors.main500,
    composes: 'title5',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'row',
    marginBottom: '12px',
  },
  link: {
    alignItems: 'center',
    composes: 'body5',
    display: 'flex',
    flexDirection: 'row',
    marginBottom: '8px',
  },
  linkIcon: {
    marginRight: '4px',
  },
  linkSection: {
    marginBottom: '20px',
  },
  title: {
    color: Colors.grey900,
    composes: 'h1',
    marginBottom: '24px',
  },
});

const DIRECTORY_LINK_NAMES = [
  LinkNames.AccountLinking,
  LinkNames.AccountLinkingNoShipping,
  LinkNames.Continue,
  LinkNames.NoFlows,
  LinkNames.SPBv4,
  LinkNames.SPBv5,
  LinkNames.Vcc,
  LinkNames.LegacyPayPal,
];

const LINK_TITLE_MAP = {
  [LinkNames.AccountLinking]: 'Account Linking',
  [LinkNames.AccountLinkingNoShipping]: 'Account Linking - No Shipping',
  [LinkNames.Continue]: 'Continue Page',
  [LinkNames.NoFlows]: 'No Flows',
  [LinkNames.SPBv4]: 'SPB v4',
  [LinkNames.SPBv5]: 'SPB v5',
  [LinkNames.Vcc]: 'VCC Flows (VCC)',
  [LinkNames.LegacyPayPal]: 'Legacy PayPal Button',
};

const STORES_TOGGLE_NAME = 'toggleStoresLinks';
const ALL_TOGGLE_NAME = 'toggleAllLinks';

const getArrowIcon = (collapsed: boolean) => (collapsed ? 'arrowhead_down' : 'arrowhead_up');

function Directory(): ReactElement {
  const classes = useStyles();
  const [expandedStores, setExpandedStores] = useState<boolean>(localStorage.getItem(STORES_TOGGLE_NAME) === '1' || true);
  const [expandedAll, setExpandedAll] = useState<boolean>(localStorage.getItem(ALL_TOGGLE_NAME) === '1' || false);

  const expandStoreLinks = () => {
    setExpandedStores(!expandedStores);
    localStorage.setItem(STORES_TOGGLE_NAME, expandedStores ? '0' : '1');
  };

  const expandAllLinks = () => {
    setExpandedAll(!expandedAll);
    localStorage.setItem(ALL_TOGGLE_NAME, expandedAll ? '0' : '1');
  };

  const renderDirectoryLinks = () => Object.values(DIRECTORY_LINK_NAMES).map(linkName => (
    <div key={ linkName } className={ classes.link }>
      <Icon name="store" size={ 24 } color="orange" type="fill" className={ classes.linkIcon } />
      <Link key={ window.location.pathname } to={ LINK_TO_PATH_MAP[linkName].to }>{ LINK_TITLE_MAP[linkName] }</Link>
    </div>
  ));

  const renderAllLinks = () => Object.values(LinkNames).map(linkName => (
    <div key={ linkName } className={ classes.link }>
      <Icon name="arrow_right" size={ 24 } color="orange" className={ classes.linkIcon } />
      <Link key={ window.location.pathname } to={ LINK_TO_PATH_MAP[linkName].to }>{ LINK_TO_PATH_MAP[linkName].to }</Link>
    </div>
  ));

  return (
    <div className={ classes.container }>
      <div className={ classes.title }>Mock Checkout Stores Directory</div>
      <div className={ classes.linkSection }>
        <div className={ classes.expandButton } onClick={ expandStoreLinks }>
          Stores
          <Icon name={ getArrowIcon(expandedStores) } size={ 24 } color="black" className={ classes.collapseArrow } />
        </div>

        <Collapse in={ expandedStores }>
          <div className={ classes.collapsibleContent }>
            { renderDirectoryLinks() }
          </div>
        </Collapse>
      </div>

      <div className={ classes.linkSection }>
        <div className={ classes.expandButton } onClick={ expandAllLinks }>
          All links
          <Icon name={ getArrowIcon(expandedAll) } size={ 24 } color="black" className={ classes.collapseArrow } />
        </div>

        <Collapse in={ expandedAll }>
          <div className={ classes.collapsibleContent }>
            { renderAllLinks() }
          </div>
        </Collapse>
      </div>
    </div>
  );
}

export default Directory;
